import { Link } from 'foundations-components/transitional/components/Link';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { jsx as _jsx } from "react/jsx-runtime";
export function PolymorphicLink({
  linkMode,
  href,
  children,
  use
}) {
  return linkMode === 'react-router' ? /*#__PURE__*/_jsx(UIRouterLink, {
    to: href,
    use: use,
    children: children
  }) : /*#__PURE__*/_jsx(Link, {
    href: href,
    use: use,
    children: children
  });
}